import { AIAgents } from "modules/aiAgents";

const AIAgentsPage = () => {
  return <AIAgents />;
};

export default AIAgentsPage;
